<template>
  <div class="box">
    <Header :active="active" />
    <Banner />
    <div class="one nomal">
      <div class="publictitle">
        <p class="pli">关于大儒</p>
        <!-- <p class="pli1">About Daru</p> -->
      </div>
     
      <div class="inner shadow">
        <el-row>
          <el-col :span="12">
            <img
              v-if="!img"
              class="oneleft"
              src="../assets/images/11.jpg"
              alt=""
            />
            <img v-else class="oneleft" :src="img" alt="" />
          </el-col>
          <el-col :span="12">
            <div v-html="article" class="oneright nomal"></div>
          </el-col>
        </el-row>
      </div>
    </div>
    <!-- <div class="two">
      <img class="publicimg" src="../assets/images/4.jpg" alt="" />
      <div class="inner">
        <img
          style="diplay: block; width: 100%"
          src="../assets/images/12.jpg"
          alt=""
        />
        <div class="white">
          <div
            @click="goXu(item)"
            v-for="(item, index) in xuList"
            :key="index"
            class="item list"
          >
            <div>{{ item.title }}</div>
            <div class="time">{{ item.fabuTime }}</div>
          </div>
          <div @click="goXU" class="gd">查看更多>></div>
        </div>
      </div>
    </div>
    <div class="three">
      <img class="publicimg" src="../assets/images/5.jpg" alt="" />
      <div class="inner swiper">
        <div class="item silde">
          <div
            @click="goTeamInner(item)"
            v-for="(item, index) in teamList"
            :key="index"
          >
            <img :src="item.img" alt="" />
            <p class="color">
              {{ item.name }} 
            </p>
            <p>{{ item.job }}</p>
          </div>
        </div>
        <div @click="goTeam" class="gd">查看更多>></div>
      </div>
    </div> -->
    <div class="four">
      <div class="publictitle">
        <p class="pli">咨询流程&咨询方式</p>
        <!-- <p class="pli1">Consultation process & Consultation method</p> -->
      </div>
     
      <img class="liucheng" src="../assets/images/16.jpg" alt="" />
    </div>
    <div class="five">
      <div class="publictitle">
        <p class="pli">我们的服务</p>
        <!-- <p class="pli1">Our services</p> -->
      </div>
      <div class="inner clearfix fiveInner">
        <div class="for">
          <img src="../assets/images/17.jpg" alt="" />
          <div>青少年心理咨询服务</div>
        </div>
        <div class="for">
          <img src="../assets/images/18.jpg" alt="" />
          <div>婚姻情感咨询服务</div>
        </div>
        <div class="for">
          <img src="../assets/images/19.jpg" alt="" />
          <div>情绪和压力管理</div>
        </div>
        <div class="for">
          <img src="../assets/images/20.jpg" alt="" />
          <div>自我探索和发展</div>
        </div>
        <div class="for">
          <img src="../assets/images/21.jpg" alt="" />
          <div>企业家心理顾问</div>
        </div>
        <div class="for">
          <img src="../assets/images/22.jpg" alt="" />
          <div>心理创伤咨询与危机干预</div>
        </div>
      </div>
    </div>
    <Map ref="map" />
    <Foot />
    <Right />
  </div>
</template>

<script>
import Right from "../components/Right.vue";
import Header from "../components/header.vue";
import Banner from "../components/banner.vue";
import Map from "../components/map.vue";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
export default {
  components: {
    Header,
    swiper,
    swiperSlide,
    Right,
    Banner,
    Map,
  },
  data() {
    return {
      active: 0,
      swiperOption: {
        loop: true,
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        // 显示分页
        pagination: {
          el: ".swiper-pagination",
          clickable: true, //允许分页点击跳转
        },
      },
      xuList: [],
      teamList: [],
      img: "",
      article: null,
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
  created() {},
  mounted() {
  
    document.documentElement.scrollTop=0
    document.getElementById("container").innerHTML = "";
    //获取徐凯文专栏
    this.getXu();
    //咨询师团队
    this.getTeam();
    //获取关于我们图片
    this.getImg();
    //关于我们
    this.getArticle();
  },
  beforeDestroy() {
    this.$refs.map.destroy();
  },
  methods: {
    goTeamInner(item) {
      sessionStorage.setItem("team", JSON.stringify(item));
      this.$router.push(`/teaminner`);
    },
    getXu() {
      var data = {
        limit: 5,
        page: 1,
        type: 0,
      };
      this.$get("/web/api/list_article", data).then((res) => {
        if (res.code == 200) {
          this.xuList = res.data.list;
        }
      });
    },
    goXU() {
      this.$router.push("/xu");
    },
    getTeam() {
      var data = {
        limit: 4,
        page: 1,
      };
      this.$get("/web/api/get_list_team", data).then((res) => {
        if (res.code == 200) {
          this.teamList = res.data.list;
        }
      });
    },

    getImg() {
      this.$get("/web/api/get_about_us_img", {}).then((res) => {
        if (res.code == 200) {
          this.img = res.data;
        }
      });
    },
    getArticle() {
      this.$get("/web/api/get_about_us_txt", {}).then((res) => {
        if (res.code == 200) {
          this.article = res.data;
        }
      });
    },
    getLink() {
      this.$get("/web/api/list_link", {}).then((res) => {
        if (res.code == 200) {
          this.linkList = res.data;
        }
      });
    },
    getus() {
      this.$get("/web/api/get_lx_us_txt", {}).then((res) => {
        if (res.code == 200) {
          this.phone = res.data;
        }
      });
    },
    goXu(item) {
      sessionStorage.setItem("xu", JSON.stringify(item));
      this.$router.push(`/xuinner`);
    },
    goTeam() {
      this.$router.push(`/team`);
    },
  },
};
</script>

<style  scoped>
.one {
  background-image: url(../assets/images/10.jpg);
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  height: 630px;
  padding: 40px 0 65px;
}
.publicimg {
  margin: 0 auto 30px;
  display: block;
}
.oneleft {
  display: block;
  height: 435px;
  width: 100%;
}
.oneright {
  height: 435px;
  background-color: #fff;
  padding: 40px 20px;
  overflow: auto;
  text-align: justify;
  line-height: 26px;
  overflow: auto;
}
.shadow {
  box-shadow: 5px 5px 5px #9da9b5;
}
.two {
  background-color: #f4f4f4;
  padding: 39px 0 30px;
}
.white {
  padding: 25px;
  background-color: #fff;
}
.list {
  align-items: center;
  justify-content: space-between;
  line-height: 54px;
  border-bottom: 1px dashed #e2e2e2;
  cursor: pointer;
}
.time {
  color: #737373;
  display: block;
  flex-shrink: 0;
}
.list > div:first-child {
  width: 1000px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.gd {
  width: 140px;
  text-align: center;
  line-height: 40px;
  cursor: pointer;
  color: #fff;
  background-color: #3c93d6;
  margin: 25px auto 0;
}
.three {
  background-color: #e9f0f8;
  padding: 40px 0 25px;
}
.swiper {
  padding: 14px 0 25px 0;
  background-color: #fff;
}

.silde > div {
  width: 300px;
  margin-right: 10px;
  cursor: pointer;
}
.silde > div:nth-child(4) {
  margin-right: 0;
}
.silde div img {
  display: block;
  width: 100%;
  height: 168px;
  /* height: 390px; */
}
.silde div p {
  text-align: center;
  line-height: 34px;
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.recommendPage .swiper-container {
  position: relative;
  width: 100%;
  height: 200px;
  background: pink;
}
.recommendPage .swiper-container .swiper-slide {
  width: 100%;
  line-height: 200px;
  background: yellowgreen;
  color: #000;
  font-size: 16px;
  text-align: center;
}
.four {
  padding: 50px 0;
}
.liucheng {
  display: block;
  width: 1020px;
  margin: 0 auto;
}
.five {
  padding: 50px 0;
  background-color: #f4f4f4;
}
.fiveInner > div:nth-child(3n) {
  margin-right: 0;
}
.for {
  width: 390px;
  background-color: #fff;
  margin-right: 30px;
  padding: 30px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-weight: bold;
  float: left;
  margin-bottom: 30px;
}
.for img {
  display: block;
  width: 85px;
  height: 85px;
  margin-bottom: 12px;
}

/* 地图 */
.six {
  padding: 50px 0;
  background-color: #eff9f8;
}
.seven {
  padding: 50px 0;
}
.publicimg {
  margin: 0 auto 30px;
  display: block;
}
.fl {
  justify-content: space-between;
  display: flex;
}
#container {
  display: block;
  width: 660px;
  height: 270px;
}
.dar {
  padding: 50px 0 22px;
  border-bottom: 1px solid #7d7d7d;
  font-size: 24px;
}
.imglist img {
  display: block;
  width: 230px;
  height: 107px;
  margin-right: 20px;
  float: left;
  margin-bottom: 20px;
}
.imglist > img:nth-child(5n) {
  margin-right: 0;
  
}
.color{
  font-weight: bold;
  color: #3c93d6;
}
</style>